import { MainThunkDispatch, State } from "../../../Reducers"
import { failMessage, successMessage } from "../../Client/MessagesActions"
import { InstanceAPIType } from "../../Types"
import { APIAppInstanceModel } from "../../../Models/API/AppInstanceModel"
import { MetricRequest } from "../../../Models/Client/MetricRequest"
import { AppInstanceCustomizeAction } from "../../../Reducers/API/AppInstance/AppInstanceCustomizeReducer"
import { apiFetch } from "../../Client/NetworkActions"
import { safePromise } from "../../../Helpers/Functions/promise"
import { apiEndpoints } from "../../../Routes/api"
import { getInstance } from "./AppInstanceActions"
import { hasValue } from "../../../Models/Client/FetchState"

export const setMetricToOptimize = (
    appID: string,
    attrIds: string[]
): AppInstanceCustomizeAction => {
    return {
        type: InstanceAPIType.customizeMetrics_chooseMetricToOptimize,
        payload: {
            appID,
            attrIds
        }
    }
}

export const setQualityMetricToOptimize = (
    appID: string,
    attrId?: string
): AppInstanceCustomizeAction => {
    return {
        type: InstanceAPIType.customizeMetrics_chooseQualityMetricToOptimize,
        payload: {
            appID,
            attrId
        }
    }
}

export const getCustomizeMetrics =
    (appID: string) => async (dispatch: MainThunkDispatch) => {
        const { data, error } = await safePromise(
            dispatch(
                apiFetch(
                    `GET_INSTANCE_METRICS_${appID}`,
                    apiEndpoints.getInstanceMetricsByID({ id: appID })
                )
            )
        )

        if (error !== undefined || data === undefined) {
            return
        }

        const action: AppInstanceCustomizeAction = {
            type: InstanceAPIType.customizeMetrics_latestFetched,
            payload: {
                appID,
                metrics: data
            }
        }

        dispatch(action)
    }

export const saveCustomizeMetrics =
    (appID: string, metric: MetricRequest) =>
    async (dispatch: MainThunkDispatch, getState: () => State) => {
        const app = getState().api.apps.apps.records.get(appID)

        if (
            !hasValue(app) ||
            app.value.templateName === null ||
            app.value.templateName === undefined
        ) {
            return
        }

        const template = getState().api.templates.records.get(
            app.value.templateName
        )

        if (!hasValue(template)) return

        const options: RequestInit = {
            method: "PUT",
            body: JSON.stringify({
                appId: appID,
                appMetrics: {
                    metric: { ...metric, workflow: undefined }
                }
            })
        }

        const { data, error } = await safePromise(
            dispatch(
                apiFetch(
                    `PUT_INSTANCE_METRICS_${appID}`,
                    apiEndpoints.getInstanceMetricsByID({ id: appID }),
                    options
                )
            )
        )

        if (error !== undefined || data === undefined) {
            if (error !== undefined)
                dispatch(
                    failMessage("Failed to update performance option", error)
                )
            return
        }

        await dispatch(getInstance(appID))
        dispatch(successMessage("Performance settings updated"))
    }

export const setInstanceParameters =
    (id: string, parameters: any, squashSuccessMessage: boolean) =>
    async (
        dispatch: MainThunkDispatch
    ): Promise<APIAppInstanceModel | undefined> => {
        const options: RequestInit = {
            method: "PATCH",
            body: JSON.stringify({
                appParams: parameters
            })
        }

        const { data, error } = await safePromise(
            dispatch(
                apiFetch(
                    `UDPDATE_INSTANCE_PARAMS_${id}`,
                    apiEndpoints.getInstanceByID({ id }),
                    options
                )
            )
        )

        if (error !== undefined || data === undefined) {
            if (error !== undefined)
                dispatch(failMessage("Could not update job design", error))
            return
        }

        dispatch({
            type: InstanceAPIType.addInstance,
            payload: data
        })

        if (!squashSuccessMessage) {
            dispatch(successMessage("Successfully updated job design"))
        }

        return data
    }
